
import Vue from 'vue';

export default Vue.extend({
  name: 'More',
  props: {
    text: {
      type: String,
      default: '查看更多',
    },
  },
});
